export default "__VITE_ASSET__04cdbafd__"